import {apiCredential} from "../../../../libraries/api-credential";
import {ContentType} from "ct-library-api-credential";
import {
  validationCodeRequest,
  validationCodeResponse,
} from "../types/code.types";

export const CodeAPI = {
  validateCode: async (
    request: validationCodeRequest,
  ): Promise<validationCodeResponse> => {
    try {
      const response = await apiCredential.call<validationCodeResponse>({
        path: `/api/v1/chat/check-codes`,
        method: "POST",
        format: "json",
        type: ContentType.Json,
        body: request.data,
        credentials: "include",
      });

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
};
